import { createContext } from 'react'
import { useImageFormat } from '@/composables/useImageFormat'

export const ImageFormatContext = createContext<string>('png')

type ImageFormatContextroviderProps = {
  children: React.ReactNode
}

export const ImageFormatProvider = ({ children }: ImageFormatContextroviderProps) => {
  const betterFormat = useImageFormat()

  return <ImageFormatContext.Provider value={betterFormat}>{children}</ImageFormatContext.Provider>
}
